module.exports = "https://static.wmbcdn.com/uniweb/images/976cbc9adbedea7459144908dadbcbb6.svg";